import { useEffect, useState } from "react";

export const Controls = () => {

    const [state, setState] = useState(false);

    useEffect(() => {
        if (!state) { setState(true) } else {
            const fixedLocation = window.location.href.replace('/site/#', '');
            const currentLocation = window.location.href;
            if (fixedLocation !== currentLocation) {
                setTimeout(() => {
                    window.history.back()
                }, 1000);
                window.location.href = fixedLocation;
            }
        }
    }, [state])

    return null
}